import { ReactNode } from 'react'

import { Card } from '../card/Card'
import ProgressSteps from '../progressSteps/ProgressSteps'

type WizardLayoutProps = {
  steps: string[]
  currentStep: number
  ariaLabel: string
  children: ReactNode
  cardClassName?: string
  skippedSteps?: number[]
  skippedLabel?: string
  onStepChange?: (step: number) => void
  isStepDisabled?: (step: number) => boolean
}

const WizardLayout = ({
  steps,
  currentStep,
  ariaLabel,
  children,
  cardClassName = 'col-12',
  skippedSteps,
  skippedLabel,
  onStepChange,
  isStepDisabled,
}: WizardLayoutProps) => (
  <Card className={cardClassName}>
    <div className="d-flex h-100 w-100 flex-column">
      <ProgressSteps
        className="mt-0 mb-4 py-3"
        steps={steps}
        currentStep={currentStep}
        ariaLabel={ariaLabel}
        skippedSteps={skippedSteps}
        skippedLabel={skippedLabel}
        onStepChange={onStepChange}
        isStepDisabled={isStepDisabled}
      />
      {children}
    </div>
  </Card>
)

export default WizardLayout
